import styled from 'styled-components';

export const ClientDataMailContainer = styled.div`
  padding: 16px;
  width: 100dvw;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ClientDataMailContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #f9faf9;
`;

export const ClientDataMailTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClientDataMailButton = styled.div`
  width: calc(100% - 32px);
  position: absolute;
  padding: 16px;
  bottom: 16px;
`;
